import React, { Component } from 'react';
import './Header.scss';
import './Profiledropdown.scss';
import { Dropdown } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import routePaths from '../../shared/constants/routePaths';
import { AuthActions } from '../../store/auth';

import { ApplicationState } from '../../store';
import { connect } from 'react-redux';
import { Avatar } from 'primereact/avatar';

interface ComponentProps {
    name?: string;
    username?: string;
    state?: ApplicationState;
}

type DashboardLayoutProps =
    ComponentProps
    & typeof mapDispatchToProps;

    const clearAppCache = () => {
        localStorage.clear(); // Clears all items in localStorage
        sessionStorage.clear(); // Clears all items in sessionStorage
      };
      const handleLogout = () => {
        clearAppCache();
        sessionStorage.setItem('isLoggedOut', 'true');
        window.location.reload();
      };    

class Header extends Component<DashboardLayoutProps> {
    appLogo = require('../../assets/Horizontal- black background.png');
    appLogoMobile = require('../../assets/UNIFI-Logo.png');

    async componentDidMount() {
        this.update();
        window.addEventListener('resize', this.update.bind(this));
    }

    private update = () => {
        this.setState({ userScreenWidth: window.innerWidth });
    };

    onSignOut = () => {
        if (this.props.state?.internalUser.isAuthenticated) {
            this.props.internalSignOut();
        }
    };

    getInitials(fullName?: string): string {
        if (!fullName) {
            return '';
        }
        // Split the full name into an array of names
        const names = fullName.split(' ');

        // Take the first letter from the first and second names
        const initials = names.slice(0, 2).map(name => name[0]).join('');

        return initials.toUpperCase();
    }

    

    render() {
        const { username, name } = this.props;
        return (
            <>
                <div className="dashboard-app-bar">
                    
                    <NavLink className="appLogoContainer col-1" to={routePaths.root}>
                        <picture>
                            <source media="(max-width: 1555px)" srcSet={this.appLogoMobile} />
                            <source media="(min-width: 993px)" srcSet={this.appLogo} />
                            <img className="appLogo" alt="Unifi Icon" src={this.appLogo} />
                        </picture>
                    </NavLink>
                    
                    <div className="dashboard-appTitle col-6">
                        <NavLink className="dashboard-appTitle" to={routePaths.root}>
                            <span className="dashboard-appTitle">Callout App</span>
                        </NavLink>
                    </div>
                    {username && (
                        <>
                        <div className='user-name-section col-5 '>
                            <div className='profile-dropdown'>
                            {/* <Dropdown>
                                <Dropdown.Toggle variant="">
                                    {name && <div>
                                        <Avatar label={this.getInitials(name)} style={{ backgroundColor: '#2196F3', color: '#ffffff' }} shape="circle" />
                                    </div>}
                                    {!name && <div>
                                        <Avatar icon="pi pi-user" style={{ backgroundColor: '#2196F3', color: '#ffffff' }} shape="circle" />
                                    </div>}
                                </Dropdown.Toggle>
                                <Dropdown.Menu >
                                   
                                        <div className='dropdown-content'>
                                            <div className='profile-info'>
                                            <div className='profile-initials'>

                                            {name && 
                                                <Avatar label={this.getInitials(name)} style={{ backgroundColor: '#2196F3', color: '#ffffff' }} shape="circle" />
                                            }
                                            {!name && 
                                                <Avatar icon="pi pi-user" style={{ backgroundColor: '#2196F3', color: '#ffffff' }} shape="circle" />
                                            }

                                            </div>
                                            <div className='profile-details'>
                                                <div className='profile-name'>{name}</div>
                                                <div className='profile-email'>{username}</div>
                                            </div>
                                            </div>
                                            
                                            <div className='logout' onClick={handleLogout}>Sign out</div>
                                        </div>
                                    
                                    
                                </Dropdown.Menu>
                            </Dropdown> */}


                            
                                    {name && <div>
                                        <Avatar label={this.getInitials(name)} style={{ backgroundColor: '#2196F3', color: '#ffffff' }} shape="circle" />
                                    </div>}
                                    {!name && <div>
                                        <Avatar icon="pi pi-user" style={{ backgroundColor: '#2196F3', color: '#ffffff' }} shape="circle" />
                                    </div>}
                                   
                                        <div className='dropdown-content'>
                                            <div className='profile-info'>
                                            <div className='profile-initials'>

                                            {name && 
                                                <Avatar label={this.getInitials(name)} style={{ backgroundColor: '#2196F3', color: '#ffffff' }} shape="circle" />
                                            }
                                            {!name && 
                                                <Avatar icon="pi pi-user" style={{ backgroundColor: '#2196F3', color: '#ffffff' }} shape="circle" />
                                            }

                                            </div>
                                            <div className='profile-details'>
                                                <div className='profile-name'>{name}</div>
                                                <div className='profile-email'>{username}</div>
                                            </div>
                                            </div>
                                            {/* <div className='profile-links'>
                                            <a href="#">View account</a>
                                            <a href="#">My Microsoft 365 profile</a>
                                            </div> */}
                                            <div className='logout' onClick={handleLogout}>Sign out</div>
                                        </div>
                                
                            </div>
                            </div>
                        </>
                    )}

                </div>
            </>

        );
    }
}

const mapStateToProps = (state: ApplicationState, ownProps: any): DashboardLayoutProps => {

    return {
        ...state,
        state: state,
        ...ownProps,
    };
};

const mapDispatchToProps = {
    internalSignOut: AuthActions.signOut
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
